












import { Vue, Component } from 'vue-property-decorator'

import { RUN_APP, APP } from '@common/loan-act/env'


const AdConfig = {
  [APP.ssj]: [
    {
      icon: 'star',
      h1: '安心借',
      p: '25年财务管理沉淀<br/>2.2亿用户信赖'
    },
    {
      icon: 'mark',
      h1: '额度高',
      p: '最高可借20万<br/>最快当天放款'
    },
    {
      icon: 'lightning',
      h1: '还款易',
      p: '3-12期任意选择<br/>手机APP一键操作'
    },
  ],
  [APP.kn]: [
    {
      icon: 'star',
      h1: '安心借',
      p: 'C轮融资2亿美金<br/>8000万用户信赖'
    },
    {
      icon: 'mark',
      h1: '额度高',
      p: '最高可借20万<br/>最快当天放款'
    },
    {
      icon: 'lightning',
      h1: '还款易',
      p: '3-12期任意选择<br/>手机APP一键操作'
    },
  ],
}

@Component
export default class Introduce extends Vue {
  get ad() {
    return AdConfig[RUN_APP]
  }
}
